import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, filter, from, switchMap, take, tap } from 'rxjs';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import { SessionService } from 'src/app/services/session/session.service';
import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * Interceptor adds the user's auth token to any HTTP request
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Default constructor for the interceptor 
     * @param _userService
     */
    constructor(
        private _authService: AuthService,
    ) { }

    /**
     * Intercept any HTTP request 
     * @param req
     * @param next 
     * @returns HTTP Response
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Wait for any token refresh to complete before proceeding
        return this._authService.refreshInProgress$.pipe(
            filter(inProgress => {
                if (inProgress) console.log(`[AUTH-INTERCEPTOR]: refresh blocking ${req.url}`)
                return !inProgress;
            }), // Only proceed if not refreshing
            take(1),
            switchMap(() => {
                // If the request is going to a "token/**" endpoint, do not add the token
                if (req.url.includes(`${environment.baseUrl}/token/`)) {
                    return next.handle(req);
                }

                // Check token status
                const token = this._authService.token;
                if (token == undefined || token === "") {
                    // If the token is empty, just let the request go through
                    return next.handle(req);
                }

                // Otherwise, add the token to the request
                const reqCopy = req.clone({
                    headers: req.headers.set('Authorization', `Bearer ${token}`),
                });
                return next.handle(reqCopy);
            })
        );
    }
}